/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import { mapDispatch, navTo, numberWithCommas, setToken } from '../utils/util';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';
import FontAwesome from 'react-fontawesome';

import OzComponent from '../lib/OzComponent';
import Wrapper from './Wrapper';
import './AboutUs.css';
import WhereField from './partials/WhereField';
import LeaderboardStats from './partials/LeaderboardStats';
import RegisterForm from './partials/RegisterForm';
import {
  login,
  register,
  fetchUser,
} from '../actions';

class AboutUs extends OzComponent {

  state = {};

  render() {
    return (
      <Wrapper className="AboutUs" title="About Us" padded>
        <div className="two">
          <div className="cell photo-cell">
            <div className="photo"></div>
          </div>

          <div className="cell text-cell">
            <p>Hi! I'm Marcell, the founder of EscapeSpy. I'm an an escape room enthusiast, and I made the site to make it easier to find escape rooms. I used to open a dozen or more tabs on my phone to find an escape room I could do right away. This wasn't a great experience, and I wanted to make something better. I wrote the first version of EscapeSpy to index all the escape rooms in the Bay Area, and crawl their availability. This made it a lot easier to find rooms to do.</p>
            <p>Since then, I've worked on expanding EscapeSpy to work in more cities. We crawl escape rooms all across America, and we're expanding to cover international escape rooms as well! My hope is that this site will make escape rooms easier to find and book for all enthusiasts, as well as people new to escape rooms.</p>
            <p>I love hearing from users, so if you want to get in touch, please use the chat button, or email me at <b><a href="mailto:marcell@escapespy.com">marcell@escapespy.com</a></b>.</p>

            <h2>Press</h2>
            <p><b><a href="https://theescaperoomguys.com/2019/12/11/need-a-one-stop-shop-for-booking-an-escape-room/">Need a One-Stop-Shop for Booking an Escape Room?</a></b> - <i><a href="https://theescaperoomguys.com">The Escape Room Guys</a></i></p>
            <p><b><a href="https://www.facebook.com/1736195140016456/posts/2263909123911719/?d=n">Key to Escape</a></b></p>
          </div>
        </div>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    login,
    register,
    fetchUser,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AboutUs);



/** WEBPACK FOOTER **
 ** ./src/components/AboutUs.js
 **/